import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { ToastrService } from "ngx-toastr";
import { Package } from "src/app/dto";
import { HttpPackageService } from "src/app/service/http-package.service";
import { RefService } from "src/app/service/ref.service";
import { PackageDataLoaderService } from "./services/package.lov.data.loader.service";

@Component({
    selector: "app-home",
    templateUrl: "./home.component.html",
    styleUrls: ["./home.component.scss"],
})
export class HomeComponent implements OnInit {
    ref: string = null;
    continuePossible: boolean = false;

    package: Package = {
        id: "1",
        brand: "",
        name: "",
        image: "1_iPhone13_200x200.png",
        display: {
            description: ""
        },
        chipset: {
            description: ""
        },
        storage_ram: {
            description: ""
        },
        camera: {
            description: ""
        },
        network: {
            description: ""
        },
        battery: {
            description: ""
        },
        price_per_month: ""
    };

    packages: Array<Package> = [];

    constructor(
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private toastr: ToastrService,
        private refService: RefService,
        private httpPackageService: HttpPackageService,
        private translateService: TranslateService,
        private packageDataLoaderService: PackageDataLoaderService
    ) { }

    ngOnInit(): void {
        this.activatedRoute.queryParamMap.subscribe((params) => {
            this.ref = params.get("ref");
            this.refService.setRef(this.ref);

            this.packageDataLoaderService.loadData().subscribe((data) => {
                this.packages = data;
                this.getPackage();
            });
        });
    }

    private getPackage() {
        this.httpPackageService.getPackage(this.ref).subscribe(
            (res) => {
                if (res.responseCode === "0") {                 
                    this.package = this.packages.find((p) => +p.id === +res.packageEntity.packageId);
                    this.continuePossible = true;
                } else {
                    this.handleErrors("error.package.not.found", res.responseMessage);
                    this.continuePossible = false;
                }
            },
            (error) => {
                this.handleErrors("error.package.not.found", error.error);
                this.continuePossible = false;
            }
        );
    }

    private handleErrors(translateKey: string, result?: string): boolean {
        this.translateService.get(translateKey).subscribe((res: string) => {
            let message = res;
            if (!res || res.length <= 0) {
                message = result;
            }

            this.toastr.error(message, "Error");
        });

        return true;
    }

    continue() {
        this.router.navigate(["/consent"]);
    }
}
